var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.5C9.82843 4.5 10.5 3.82843 10.5 3C10.5 2.17157 9.82843 1.5 9 1.5C8.17157 1.5 7.5 2.17157 7.5 3C7.5 3.82843 8.17157 4.5 9 4.5Z",
    fill: "#00446B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9175 6.0825C11.625 5.79 11.1225 5.25 10.1475 5.25C9.99 5.25 9.0825 5.25 8.2425 5.25C6.18 5.2425 4.5 3.5625 4.5 1.5H3C3 3.87 4.5825 5.88 6.75 6.5325V16.5H8.25V12H9.75V16.5H11.25V7.5375L14.2125 10.5L15.27 9.4425L11.9175 6.0825Z",
    fill: "#00446B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.d858908e3d3c8e87843124100aeb6496.svg";
export { ForwardRef as ReactComponent };